import {Component, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {SipManipulationGroupApiService} from '../../../services/api/settings/call-flow-configurations/sip-manipulation-groups/sip-manipulation-group-api.service';
import {AcDialogService} from 'ac-infra';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import _ from 'lodash';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SipManipulationGroupsDialogComponent} from './sip-manipulation-groups-dialog/sip-manipulation-groups-dialog.component';
import {SipConditionGroupApiService} from '../../../services/api/settings/call-flow-configurations/sip-condition-group/sip-condition-group-api.service';
import Search from '../../../utils/search';
import {SipHeadersService} from '../../../services/common/sip-headers/sip-headers.service';
import {AttributeManipulationGroupsApiService} from '../../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {forkJoin} from 'rxjs';
import Formatting from '../../../utils/formatting';
import {PrefixGroupsApiService} from '../../../services/api/settings/call-flow-configurations/prefix-groups/prefix-groups-api.service';
import {NumberPortabilityApiService} from '../../../services/api/settings/call-flow-configurations/number-portability/number-portability-api.service';

@Component({
  selector: 'sip-manipulation-groups',
  templateUrl: './sip-manipulation-groups.component.html',
  styleUrls: ['./sip-manipulation-groups.component.scss']
})
export class SipManipulationGroupsComponent implements OnInit {

  @ViewChild(ArmTableComponent) armTable;

  isUnauthorized: boolean;
  selection: any;
  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'name', display: 'Name', selected: true, width: 200},
    {name: 'manipulationsDescription', display: 'Manipulations', selected: true, width: 500}
  ];
  filter;
  items: any;
  sipConditionGroups;
  customWebServices;

  actionsOptions: any = [];
  manipulationOps: any = [];
  normalizationGroupsOptions: any = [];
  prefixGroupsOptions: any = [];
  requestMethodsOptions: any = [];
  contentTypeOptions: any = [];

  constructor(private sipConditionGroupApiService: SipConditionGroupApiService,
              private numberPortabilityApiService: NumberPortabilityApiService,
              private sipManipulationGroupApiService: SipManipulationGroupApiService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService,
              private sipHeadersService: SipHeadersService,
              private userPrivilege: UserPrivilegeService,
              private acDialogService: AcDialogService,
              private loaderService: LoaderService,
              private prefixGroupsApiService: PrefixGroupsApiService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  onFilter(filter: any): any {
    this.armTable.firstPage();
    this.filter = filter;
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  addItem(): void {
    const dialogData: any = {
      data: {
        manipulations: [{}],
      },
      sipConditionGroups: this.sipConditionGroups,
      customWebServices: this.customWebServices,
      actionsOptions: this.actionsOptions,
      requestMethodsOptions: this.requestMethodsOptions,
      contentTypeOptions: this.contentTypeOptions,
      normalizationGroupsOptions: this.normalizationGroupsOptions,
      prefixGroupsOptions: this.prefixGroupsOptions,
      isEditMode: false
    };

    this.acDialogService.open(SipManipulationGroupsDialogComponent, {
      dialogData,
      title: 'Add Manipulation Group',
      onSubmit: () => {
        return this.sipManipulationGroupApiService.addSipManipulationGroup(dialogData.data)
          .toPromise().then(() => {
            this.refresh();
            this.snackBarService.display(`${dialogData.data.name} successfully added`);
          });
      }
    });
  }

  editItem(): void {
    const dialogData: any = {
      data: _.cloneDeep(this.selection),
      sipConditionGroups: this.sipConditionGroups,
      customWebServices: this.customWebServices,
      actionsOptions: this.actionsOptions,
      requestMethodsOptions: this.requestMethodsOptions,
      contentTypeOptions: this.contentTypeOptions,
      normalizationGroupsOptions: this.normalizationGroupsOptions,
      prefixGroupsOptions: this.prefixGroupsOptions,
      isEditMode: true
    };

    this.acDialogService.open(SipManipulationGroupsDialogComponent, {
      dialogData,
      title: 'Edit Manipulation Group',
      onSubmit: () => {
        return this.sipManipulationGroupApiService.editSipManipulationGroup(dialogData.data, dialogData.data.id)
          .toPromise().then(() => {
            this.refresh();
            this.snackBarService.display(`${dialogData.data.name} successfully updated`);
          });
      }
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the manipulation group: "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.sipManipulationGroupApiService.deleteSipManipulationGroup(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      });
    });
  }

  refresh(): void {
    this.sipHeadersService.getSipConditionTemplate().subscribe(sipConditionData => {
      this.actionsOptions = sipConditionData.manipulationHeaderActions;
      this.manipulationOps = sipConditionData.manipulationOps;
      this.requestMethodsOptions = sipConditionData.requestMethodOps;
      this.contentTypeOptions = sipConditionData.contentTypeOps;


      forkJoin([
        this.sipConditionGroupApiService.getSipConditionGroups(),
        this.attributeManipulationGroupsApiService.getAttributeManipulationGroups(),
        this.sipManipulationGroupApiService.getSipManipulationGroups(),
        this.prefixGroupsApiService.getPrefixGroupsSlim(),
        this.numberPortabilityApiService.getNumberPortabilityImplementations()

      ]).subscribe(data => {
        this.sipConditionGroups = Search.generateSearchOptions(data[0], 'name', 'id');
        this.normalizationGroupsOptions = Search.generateSearchOptions(data[1], 'groupName', 'id');
        this.prefixGroupsOptions = Search.generateSearchOptions(data[3].elements
          .filter(item => item.type === 'NUMBER'), 'name', 'id');

        this.customWebServices = Search.generateSearchOptions(data[4].filter(item => item.numberPortabilityAgentType === 'custom_http_client'), 'name', 'id');

        this.items = data[2];
        this.items.forEach(item => {
          item.manipulations.forEach(manipulation => {
            manipulation.displayData = {};

            if (manipulation.actionType === 'normalization') {
              manipulation.displayData.normalizationGroupId = this.normalizationGroupsOptions.find(ngo => {
                  return ngo.value === manipulation.normalizationGroupId;
                })?.text;
            }

            if (manipulation.actionType === 'randomFromPool') {
              manipulation.displayData.prefixGroupId = this.prefixGroupsOptions.find(pgo => {
                return pgo.value === manipulation.prefixGroupId;
              })?.text;
            }

            if (manipulation.actionType === 'sendByWebService') {
              manipulation.displayData.webServiceId = this.customWebServices.find(pgo => {
                return pgo.value === manipulation.webServiceId;
              })?.text;
            }

            manipulation.displayData.actionType = this.manipulationOps.find(actionsOption =>
              actionsOption.value === manipulation.actionType)?.text;
          });

          item.manipulationsDescription = this.generateManipulationDescription(item.manipulations);
        });
      });
    });
  }

  private generateManipulationDescription(manipulations: any): string {
    let manipulationsTemplate = '';

    manipulations.forEach((manipulation, i, array) => {
      manipulationsTemplate += `${manipulation.actionSubject} `;
      manipulationsTemplate += `${manipulation.displayData?.actionType} `;
      manipulationsTemplate += `${this.getValues(manipulation)} `;
    });

    return `${manipulationsTemplate}`;
  }

  private getValues(manipulation): string {
    if (manipulation.actionType === 'normalization') {
      return manipulation.displayData?.normalizationGroupId;
    } else if (manipulation.actionType === 'randomFromPool') {
      return manipulation.displayData?.prefixGroupId;
    }
    else if (manipulation.actionType === 'sendByWebService') {
      return manipulation.displayData?.webServiceId;
    }

    return Formatting.value(manipulation.actionValue);
  }
}
